import { render, staticRenderFns } from "./Donut.vue?vue&type=template&id=750fbc46&scoped=true&"
import script from "./Donut.vue?vue&type=script&lang=js&"
export * from "./Donut.vue?vue&type=script&lang=js&"
import style0 from "./Donut.vue?vue&type=style&index=0&id=750fbc46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750fbc46",
  null
  
)

export default component.exports